package ui.app.assign.detail.wheel.editor.pages

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import apps.App
import ssoft.frontend.generated.resources.*
import tools.rememberString
import ui.app.assign.detail.wheel.AppWheelRendererGame
import ui.app.assign.detail.wheel.AppWheelRendererReward
import ui.app.assign.detail.wheel.AppWheelRendererStartup
import ui.app.assign.detail.wheel.editor.AppEditorWheelScope
import ui.app.assign.detail.wheel.editor.AppEditorWheelVM


@Composable
fun AppEditorWheelScope.AppWheelPage05_Summary(nnvl: AppEditorWheelScope.Wrapper) {
    val isLand = remember {
        nnvl.orientation.state == App.Wheel.Theme.ORIENTATION_LAND
    }
    val itemModifier = if (display.isMobileOrSmall) Modifier.fillMaxWidth()
    else Modifier.width(256.dp)

    if (display.isMobileOrSmall) MobileView05(nnvl, isLand, itemModifier)
    else DesktopView05(nnvl, isLand, itemModifier)
}

@Composable
private fun AppEditorWheelScope.MobileView05(
    nnvl: AppEditorWheelScope.Wrapper,
    isLand: Boolean,
    itemModifier: Modifier
) {
    LazyColumn(
        contentPadding = PaddingValues(16.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        item {
            Startup(nnvl, itemModifier)
        }
        item {
            Game(nnvl, itemModifier)
        }
        item {
            ItemsLabel()
        }
        items(nnvl.items.state) {
            Item(nnvl, it, itemModifier)
        }
        item {
            SaveButton()
        }
    }
}

@Composable
private fun AppEditorWheelScope.DesktopView05(
    nnvl: AppEditorWheelScope.Wrapper,
    isLand: Boolean,
    itemModifier: Modifier
) {
    LazyVerticalGrid(
        columns = GridCells.FixedSize(256.dp),
        contentPadding = PaddingValues(16.dp),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        item {
            Startup(nnvl, itemModifier)
        }
        item {
            Game(nnvl, itemModifier)
        }
        item(span = { GridItemSpan(maxLineSpan) }) {
            ItemsLabel()
        }
        items(nnvl.items.state) {
            Item(nnvl, it, itemModifier)
        }
        item(span = { GridItemSpan(maxLineSpan) }) {
            SaveButton()
        }
    }
}

@Composable
private fun AppEditorWheelScope.Startup(nnvl: AppEditorWheelScope.Wrapper, itemModifier: Modifier) {
    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(
            text = Res.string.layer_bottom_wheel_page_summary_startup.rememberString()
        )
        AppWheelRendererStartup(
            nnvl = nnvl,
            modifier = itemModifier,
            padding = 0.dp
        )
    }
}

@Composable
private fun AppEditorWheelScope.Game(nnvl: AppEditorWheelScope.Wrapper, itemModifier: Modifier) {
    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(
            text = Res.string.layer_bottom_wheel_page_summary_game.rememberString(),
        )
        AppWheelRendererGame(
            nnvl = nnvl,
            modifier = itemModifier,
            padding = 0.dp
        )
    }
}

@Composable
private fun ItemsLabel() {
    Text(Res.string.layer_bottom_wheel_page_summary_reward.rememberString())
}

@Composable
private fun AppEditorWheelScope.Item(
    nnvl: AppEditorWheelScope.Wrapper,
    item: AppEditorWheelScope.ItemsWrapper.Item,
    itemModifier: Modifier
) {
    AppWheelRendererReward(
        nnvl = nnvl,
        item = item,
        boxModifier = itemModifier
    )
}

@Composable
private fun AppEditorWheelScope.SaveButton() {
    Box(Modifier.fillMaxWidth()) {
        Button(
            onClick = { action(AppEditorWheelVM.Action.Save) },
            modifier = Modifier.align(Alignment.Center)
        ) {
            Text(
                text = Res.string.layer_bottom_wheel_page_summary_save.rememberString(),
                style = MaterialTheme.typography.titleLarge,
                fontWeight = FontWeight.Bold,
                modifier = Modifier.padding(8.dp)
            )
        }
    }
}